import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const setIdToDelete = createAsyncThunk(
  'GlobalStats/setIdToDelete',
  async (id) => id
);
export const setIsConfirmationOpen = createAsyncThunk(
  'GlobalStats/setIsConfirmationOpen',
  async (type) => type
);
export const setLoading = createAsyncThunk(
  'GlobalStats/setLoading',
  async (type) => type
);
export const setLoadingMessage = createAsyncThunk(
  'GlobalStats/setLoadingMessage',
  async (type) => type
);
export const setPolyCount = createAsyncThunk(
  'GlobalStats/setPolyCount',
  async (count) => count
);
export const setSceneScreenshot = createAsyncThunk(
  'GlobalStats/setSceneScreenshot',
  async (url) => url
);

const initialState = {
  idToDelete: '',
  isConfirmationOpen: false,
  polyCount: 0,
  loading: true,
  isPublishing: false,
  loadingMessage: false,
  newObject: {},
  copied_object: null,
  activeComponentsNew: [],
  selectedLightId: null,
  sceneScreenshot: null,
  isEventsPinned: false,
};

const GlobalStatesSlice = createSlice({
  name: 'GlobalStats',
  initialState,
  reducers: {
    copyObject: (state, action) => {
      const payloadData = action.payload;
      state.copied_object = payloadData;
    },
    setIsPublishing: (state, action) => {
      state.isPublishing = action.payload;
    },
    setEventsPinned: (state, action) => {
      state.isEventsPinned = action.payload;
    },
    updateActiveComponent: (state, action) => {
      const { type, option } = action.payload;

      if (type === 'remove') {
        state.activeComponentsNew = state.activeComponentsNew.filter(
          (val) => val !== option
        );
      } else if (type === 'add') {
        if (!state.activeComponentsNew.includes(option)) {
          state.activeComponentsNew.push(option);
        }
      }
    },
    setSelectedLightId: (state, action) => {
      state.selectedLightId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Custom simple actions
      .addCase(setIdToDelete.fulfilled, (state, action) => {
        state.idToDelete = action.payload;
      })
      .addCase(setIsConfirmationOpen.fulfilled, (state, action) => {
        state.isConfirmationOpen = action.payload;
      })
      .addCase(setLoading.fulfilled, (state, action) => {
        state.loading = action.payload;
      })
      .addCase(setLoadingMessage.fulfilled, (state, action) => {
        state.loadingMessage = action.payload;
      })
      .addCase(setPolyCount.fulfilled, (state, action) => {
        state.polyCount = action.payload;
      })
      .addCase(setSceneScreenshot.fulfilled, (state, action) => {
        state.sceneScreenshot = action.payload;
      });
  },
});

export const {
  copyObject,
  updateActiveComponent,
  setSelectedLightId,
  setIsPublishing,
  setEventsPinned,
} = GlobalStatesSlice.actions;

export default GlobalStatesSlice.reducer;
